// Libs
import React from 'react';
import useTheme from 'hooks/useTheme';
// Components
import IconButton from '@mui/material/IconButton';
import Icon from './Icon';

const SyncIcon = ({ button, onClick }) => {
	const { theme } = useTheme();
	return button ? (
		<IconButton onClick={onClick}>
			<Icon fill={theme._highEmphasisColor} />
		</IconButton>
	) : (
		<Icon fill={theme._highEmphasisColor} onClick={onClick} />
	);
};

export default SyncIcon;
